import React, { useEffect, useState } from "react";
import "./css/main.css";
// import Prof from "../images/home.jpg"
import Lottie from "lottie-react";
import animationData from "./animations/Animation - 1710922815437.json"

const Main = () => {
  const [jobTitle, setJobTitle] = useState("");
  const jobTitles = ["Machine Learning.", "Software Developer.", "Data Scientist."];
  const [index, setIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [typingSpeed, setTypingSpeed] = useState(100);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentText = jobTitles[index];

      if (isDeleting) {
        setJobTitle(currentText.substring(0, jobTitle.length - 1));
      } else {
        setJobTitle(currentText.substring(0, jobTitle.length + 1));
      }

      if (!isDeleting && jobTitle === currentText) {
        setIsDeleting(true);
        setTypingSpeed(200);
      } else if (isDeleting && jobTitle === "") {
        setIsDeleting(false);
        setIndex((index + 1) % jobTitles.length);
        setTypingSpeed(100);
      }
    }, typingSpeed);

    return () => clearInterval(interval);
  }, [jobTitle, isDeleting, index, typingSpeed, jobTitles]);

  return (

  <section id="home">
    <div className="welcome-section">
      <div className="welcome-text">
        <h1>Welcome to my World</h1>
        <h2>Hi, I’m Ernest Hanson</h2>
        <h3>{jobTitle}</h3>
        <h4>based in Nairobi, Kenya.</h4>
      </div> 
      <div className="profile-image">
        <Lottie animationData={animationData}/>
      {/* <img
          src={Prof}
          alt="Software Developer "
          width="130"
          height="150"
        /> */}

      </div>
    </div>

    </section>
  );
};

export default Main;